import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
function HozItem({ article }) {
    return (
        <div className="card mb-3">
            <div className="row no-gutters">
                <div className="col-md-4">
                    <Link to={"/detail/" + article.designation}>
                        <LazyLoadImage
                            src={article.pathToImage}
                            className="img-size"
                            alt={"photo de " + article.designation}
                        >
                        </LazyLoadImage>
                    </Link>
                </div>
                <div className="col-md-8">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-8">
                                <h2 className="card-title">{article.designation}</h2>
                            </div>

                        </div>
                        <ul className="paginationMod pagination-sm">
                            <li className="page-item">
                                <a className="page-link" href="#">
                                    <i className="fa fa-location-arrow mr-2"></i> {article.adresse.trim() != "" ? article.adresse : "Aucune adresse spécifiée"}
                                </a>
                            </li>
                            <li className="page-item">
                                <a className="page-link" href="map.html">
                                    <i className="fa fa-street-view mr-2"></i> {article.distance} km de votre position, voir la carte
                      </a>
                            </li>
                        </ul>
                        <p className="card-text">
                            {article.description}
                        </p>
                        <ul className="pagination pagination-sm">
                            <li className="page-item">
                                <a className="page-link" href="#">
                                    <i className="fa blue fa-mobile mr-2"></i><span>{article.telephone.trim() != "" ? article.telephone : "Aucun téléphone spécifiée"}</span>
                                </a>
                            </li>
                        </ul>
                        <Link to={"/detail/" + article.designation} className="btn btn-primary">Voir les détails</Link>

                    </div>
                </div>
            </div>
        </div>);
}



export default HozItem;